import { useState } from "react";

import { postTrackingData } from "@/api/endpoints/track";
import { useMentionCard } from "@/containers/MentionCard/context";
import { getShowName } from "@/containers/MentionCard/utils/getShowName";
import SourceDisplay from "@/containers/SourceDisplay";
import { EVENT } from "@/tracking_events";
import { isSourceWithTitle, pluralize } from "@/utils";
import ExpandDescription from "@components/ExpandDescription";
import Typography from "@components/Typography";

import styles from "./Header.module.css";

const Header = (props) => {
  const {
    channel: { website_url, name: channel_name, channel_type, external_source },
    episode: { title, public_url },
    mentions,
    episodeNameMentions,
    episodeDescriptionMentions,
    channelTitleMentions,
  } = useMentionCard();

  const [showFullDescription, setShowFullDescription] = useState(false);

  // Update this to use a property that includes all the mentions
  const mentionsCount = mentions?.length;

  const track = (context) => {
    postTrackingData(EVENT.EXTERNAL_URL_CLICK, {
      url: props.share_url,
      source: props.audio_url,
      context,
    });
  };

  return (
    <div className={styles.root} {...props}>
      <div className={styles.sourceDisplayWrapper}>
        <SourceDisplay
          title={title}
          source={channel_type}
          external_source={external_source}
        />
        {mentionsCount ? (
          <Typography
            className={styles.mentionCounter}
            variant="caption"
            data-testid="mentions-counter"
          >
            • {mentionsCount}{" "}
            {pluralize(
              mentionsCount,
              L.MENTIONS_VIEW_MENTIONS_COUNT_SINGULAR,
              L.MENTIONS_VIEW_MENTIONS_COUNT_PLURAL
            )}
          </Typography>
        ) : null}
      </div>

      <Typography
        block
        className="highlight-match"
        data-testid="show-title"
        variant="subtitle-1"
        {...(website_url
          ? {
              component: "a",
              href: website_url,
              target: "_blank",
              rel: "noreferrer",
              onClick: () => track("show"),
            }
          : {})}
        dangerouslySetInnerHTML={{
          __html: getShowName({
            name:
              channelTitleMentions.length > 0
                ? channelTitleMentions[0].text
                : channel_name,
            channel_type,
          }),
        }}
      />

      {isSourceWithTitle(channel_type) ? (
        public_url ? (
          <Typography
            block
            data-testid="episode-title"
            variant="h4"
            className="highlight-match"
            component="a"
            onClick={() => track("audio url")}
            href={public_url}
            target="_blank"
            rel="noreferrer"
            {...(title
              ? {
                  dangerouslySetInnerHTML: {
                    __html: title,
                  },
                }
              : { children: title })}
          />
        ) : (
          <Typography
            block
            data-testid="episode-title"
            className="highlight-match"
            variant="h4"
            component="span"
            rel="noreferrer"
            {...(episodeNameMentions.length > 0
              ? {
                  dangerouslySetInnerHTML: {
                    __html: episodeNameMentions[0].content,
                  },
                }
              : { children: title })}
          />
        )
      ) : null}

      {episodeDescriptionMentions.length > 0 && (
        <>
          <Typography
            component="span"
            data-testid="episode-description"
            className="highlight-match"
            dangerouslySetInnerHTML={{
              __html: showFullDescription
                ? episodeDescriptionMentions[0].display_text
                : episodeDescriptionMentions[0].trimmed_display_text,
            }}
          />

          {episodeDescriptionMentions[0].trimmed_display_text &&
            episodeDescriptionMentions[0].display_text.length >
              episodeDescriptionMentions[0].trimmed_display_text.length && (
              <ExpandDescription
                showFullDescription={showFullDescription}
                onClick={() => setShowFullDescription(!showFullDescription)}
              />
            )}
        </>
      )}
    </div>
  );
};

export default Header;
